//**
// Buttonmani custom JS

// Cover Art provided by: https://musicbrainz.org/doc/Cover_Art_Archive/API
// MBDI: https://musicbrainz.org/doc/MusicBrainz_Identifier
//**


$(function() {

  var coverAlbums = [
      "Iron Maiden - Power Slave",
      "Iron Maiden - Somewhere In Time",
      "Metallica - Ride The Lightning",
      "Metallica - Master of Puppets",
      "Soundgarden - Badmotorfinger",
      "Soundgaden - Superunknown",
      "Blondie - Blondie",
      "Pink Floyd - Dark Side of the Moon",
      "Pink Floyd - Wish You Were Here",
      "Beatles - Abbey Road",
      "Beatles - Sgt. Pepper's Lonely Heart",
      "Run D.M.C. - Raising Hell",
      "Dream Theater - Awake",
      "King Crimson - In the Court of the Crimson King",
      "System of a Down - Toxicity",
      "Misfits - Walk Among Us",
      "David Bowie - Ziggy Stardust and the Spiders From Mars",
      "Frank Zappa - Hot Rats",
      "Rush - Moving Pictures",
      "Rush - 2112",
      "Heart - Little Queen",
      "Queen - Sheer Heart Attack"
    ];
  
  console.log('Album: ' + coverAlbums[0]);

  $("#queryCover").autocomplete({
      source: coverAlbums,
      minLength: 1,
      select: function(event, ui)
      {
        console.log(ui.item.value);
        $('#coverResults').text(ui.item.value);
      }
  });

});

